// 离职反馈（培哥补充0502）
// 主管录入的离职行为观察记录，供后台查看

export const departureFeedbacks = [
  {
    feedback_id: 1,
    employee_id: 20001,
    employee_name: '周明',
    manager_email: 'manager@company.com',
    resignation_date: '2026-04-15',
    observed_behaviors: [103, 112, 113],
    behavior_details: '离职前3个月开始频繁请假，被发现更新简历并接触猎头，同时向HR打听离职流程和股票变现政策。',
    suggestions: '建议早期介入，在发现频繁请假时即安排沟通，了解真实诉求。',
    created_at: '2026-04-16 09:30:00'
  },
  {
    feedback_id: 2,
    employee_id: 20002,
    employee_name: '李娜',
    manager_email: 'manager@company.com',
    resignation_date: '2026-03-20',
    observed_behaviors: [107, 109, 110],
    behavior_details: '多次表达对薪酬的不满，近期项目失败后情绪低落，长期未获得挑战性任务。',
    suggestions: '建议及时调整薪酬结构，给予新的项目机会以重建信心。',
    created_at: '2026-03-21 14:00:00'
  },
  {
    feedback_id: 3,
    employee_id: 20003,
    employee_name: '王强',
    manager_email: 'hr_director@company.com',
    resignation_date: '2026-02-28',
    observed_behaviors: [114, 115],
    behavior_details: '因配偶工作调动需随迁，长期与家人分居两地，最终决定离职回户籍所在地。',
    suggestions: '此类家庭因素导致的离职难以通过常规手段挽留，建议做好离职交接和知识传承。',
    created_at: '2026-03-01 10:00:00'
  }
]

export function getStoreDepartureFeedbacks() {
  const s = require('../store').default
  return s.state.departureFeedbacks && s.state.departureFeedbacks.feedbacks && s.state.departureFeedbacks.feedbacks.length
    ? s.state.departureFeedbacks.feedbacks
    : departureFeedbacks
}
